import { onboardingSlice } from '../store/slice';
import { partnerUploadSlice } from '../store/uploadSlice';

export const { setPartner, setPartnerCity, updatePartner } = onboardingSlice.actions;

export const { setDocDefinitions, updateUploadFormValue } = partnerUploadSlice.actions;
